import { useEffect, useState } from 'react';

let cached: string | null = null;
let inflight: Promise<string | null> | null = null;

function resolveHealthUrl(): string {
  const base = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
  return base.replace(/\/api\/v\d+\/?$/, '') + '/health';
}

async function fetchVersion(): Promise<string | null> {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const r = await fetch(resolveHealthUrl(), { credentials: 'omit' });
      if (!r.ok) return null;
      const j = await r.json();
      cached = typeof j?.version === 'string' ? j.version : null;
      return cached;
    } catch {
      return null;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export function useBackendVersion(): { version: string | null; loading: boolean } {
  const [version, setVersion] = useState<string | null>(cached);
  const [loading, setLoading] = useState<boolean>(!cached);
  useEffect(() => {
    if (cached) return;
    let alive = true;
    fetchVersion().then(v => {
      if (alive) { setVersion(v); setLoading(false); }
    });
    return () => { alive = false; };
  }, []);
  return { version, loading };
}
